import { combineReducers } from "redux";
import ReducerFunctions from "./reducerFunctions";

export default combineReducers({
    ReducerFunctions,
})
